import {call, put, select, takeLatest} from 'redux-saga/effects'
import {
  filterDataChange,
  getAll,
  getDetail,
  getDetailOutput,
  rating,
  retryAi,
  setCurrent,
  setCurrentDetailOutput,
  setList,
  setTransactionFail,
  updateItemOutput,
  setHistoryAsMainOutput,
} from './itemRedux'
import {ResponseGenerator} from '../../../shared/models/ResponseGenerator'
import {
  getDetailItem,
  getDetailItemOutput,
  getItems,
  retryAiWithSetting,
  updateDetailItem,
  updateItemImage,
  setHistoryAsMainOutput as setHistoryAsMainOutputApi,
} from './itemApi'
import {HTTP_CODE} from '../../../shared/constants'
import {toast} from 'react-toastify'
import {ItemFilterModel} from '../models/ItemFilter'
import {OrderItemModel} from '../../orders/models/OrderItemModel'
import {cloneDeep} from 'lodash'
import {ItemStatus} from '../../orders/constants'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {ItemOutputModel} from '../models/ItemOutputModel'
import {intl} from '../../../../_metronic/i18n/i18nProvider'
import {getCurrentIntl} from '../../../shared/utils/i18nUtils'
import {updateCurrentOrderItems} from '../../orders/redux/OrderRedux'

export default function* saga() {
  yield takeLatest(
    updateItemOutput.type,
    function* updateItemOutputImage(action: ReturnType<typeof updateItemOutput>) {
      try {
        const newItem: ItemOutputModel = action.payload
        const response: ResponseGenerator = yield call(updateItemImage, newItem)
        if (response && response.status !== HTTP_CODE.SUCCESS) {
          throw new Error(response.data.message)
        }
        yield put(setCurrentDetailOutput(undefined))
        toast.success(intl.formatMessage({id: 'MESSAGE.ITEM.UPDATE_DONE'}))
      } catch (error: any) {
        const currentIntl = getCurrentIntl()
        toast.error(currentIntl.formatMessage({id: 'SERVER.' + error.message}))
      }
    }
  )
  yield takeLatest([filterDataChange.type, getAll.type], function* getAllItems() {
    try {
      const filterData: ItemFilterModel = yield select((state) => state.item.filter)
      const response: ResponseGenerator = yield call(getItems, filterData)
      if (response && response.status !== HTTP_CODE.SUCCESS) {
        throw new Error(response.data.message) //@TODO:check format
      }
      yield put(setList(response.data))
    } catch (error: any) {
      const currentIntl = getCurrentIntl()
      toast.error(currentIntl.formatMessage({id: 'SERVER.' + error.message}))
    }
  })
  yield takeLatest(
    getDetailOutput.type,
    function* getItemDetailOutput(action: ReturnType<typeof getDetail>) {
      try {
        const itemId: string = action.payload
        const response: ResponseGenerator = yield call(getDetailItemOutput, itemId)
        if (response && response.status !== HTTP_CODE.SUCCESS) {
          throw new Error(response.data.message) //@TODO:check format
        }
        yield put(setCurrentDetailOutput(response.data))
      } catch (error: any) {
        const currentIntl = getCurrentIntl()
        toast.error(currentIntl.formatMessage({id: 'SERVER.' + error.message}))
      }
    }
  )
  yield takeLatest(getDetail.type, function* getItemDetail(action: ReturnType<typeof getDetail>) {
    try {
      const itemId: string = action.payload
      const response: ResponseGenerator = yield call(getDetailItem, itemId)
      if (response && response.status !== HTTP_CODE.SUCCESS) {
        throw new Error(response.data.message) //@TODO:check format
      }
      yield put(setCurrent(response.data))
    } catch (error: any) {
      const currentIntl = getCurrentIntl()
      toast.error(currentIntl.formatMessage({id: 'SERVER.' + error.message}))
    }
  })
  yield takeLatest(rating.type, function* updateItemStar(action: ReturnType<typeof rating>) {
    try {
      const itemId: number = action.payload.id
      const star: number = action.payload.star
      const response: ResponseGenerator = yield call(updateDetailItem, itemId, star)
      if (response && response.status !== HTTP_CODE.SUCCESS) {
        throw new Error(response.data.message) //@TODO:check format
      }
    } catch (error: any) {
      const currentIntl = getCurrentIntl()
      toast.error(currentIntl.formatMessage({id: 'SERVER.' + error.message}))
    }
  })
  yield takeLatest(retryAi.type, function* updateItemStar(action: ReturnType<typeof retryAi>) {
    try {
      const newSetting = action.payload
      const currentItem: OrderItemModel | undefined = yield select((state) => state.item.current)
      if (!currentItem) {
        throw new Error('No current item found')
      }
      const response: ResponseGenerator = yield call(retryAiWithSetting, currentItem.id, newSetting)
      if (!response || response.status !== HTTP_CODE.SUCCESS) {
        throw new Error(response.data.message) //@TODO:check format
      }
      if (response.data.isSuccess) {
        let updatedItem = cloneDeep(currentItem)
        updatedItem.aiCountTime = (updatedItem.aiCountTime ?? 0) + 1
        updatedItem.status = ItemStatus.AI_PROCESSING
        updatedItem.outputImageUrl = {
          tiny: toAbsoluteUrl('/media/loading-bg.gif'),
          small: toAbsoluteUrl('/media/loading-bg.gif'),
          medium: toAbsoluteUrl('/media/loading-bg.gif'),
          original: toAbsoluteUrl('/media/loading-bg.gif'),
        }
        yield put(setCurrent(updatedItem))
        yield put(updateCurrentOrderItems([updatedItem]))
        // Note: History refresh is triggered via Firebase listener in ItemDetail.tsx
        // when AI processing completes (status changes to DONE)
      }
    } catch (error: any) {
      yield put(setTransactionFail(error.message))
    }
  })

  yield takeLatest(
    setHistoryAsMainOutput.type,
    function* handleSetHistoryAsMainOutput(action: ReturnType<typeof setHistoryAsMainOutput>) {
      try {
        const {itemId, historyId} = action.payload
        const response: ResponseGenerator = yield call(setHistoryAsMainOutputApi, itemId, historyId)
        if (!response || response.status !== HTTP_CODE.SUCCESS) {
          throw new Error(response.data.message)
        }
        // Update current item with the response data (OrderItemDto)
        yield put(setCurrent(response.data))
        yield put(updateCurrentOrderItems([response.data]))
        toast.success(intl.formatMessage({id: 'MESSAGE.ITEM.USE_HISTORY_SUCCESS'}))
      } catch (error: any) {
        const currentIntl = getCurrentIntl()
        toast.error(currentIntl.formatMessage({id: 'SERVER.' + error.message}))
      }
    }
  )
}
